import BeEndpoints from '../../services/end-points/be-endpoints';
import requestService from '../services/requestService';
import { removeBlankKeys } from '../../components/material-ui/helper';

export const fetchEMIInfo = (data, query) => {
  const request = {
    method: 'post',
    url: `${BeEndpoints.GET_EMI_INFO}`,
    data,
  };
  return requestService(query, request, (d) => d);
};

export const fetchHowToBuy = (query) => {
  const request = {
    method: 'get',
    url: BeEndpoints.GET_HOW_TO_BUY_WIDGET,
  };
  return requestService(query, request, (d) => d.data);
};

export const fetchUserEligibleEMI = (
  { mobile, amount, isCardEmiEnabled },
  query,
  overrideHeaders,
) => {
  const payLoad =
    isCardEmiEnabled || isCardEmiEnabled === undefined
      ? { mobile, amount }
      : { mobile, amount, creditSchemeType: 'CARDLESS' };
  const request = {
    method: 'post',
    url: BeEndpoints.POST_CHECK_USER_ELIGIBLE_EMI,
    data: removeBlankKeys(payLoad),
  };

  const responseDecorator = (response) => {
    const { data, headers } = response || {};
    const { success } = data || {};
    if (success) {
      if (headers) {
        const icHeaders = {};
        Object.keys(headers).forEach((headerName) => {
          if (/^ic-/.test(headerName)) {
            icHeaders[headerName] = headers[headerName];
          }
        });
        if (data && data.data) data.data['responseICHeaders'] = icHeaders;
      }
    }
    return { data };
  };
  return requestService(
    query,
    request,
    (d) => d.data,
    null,
    responseDecorator,
    overrideHeaders,
  );
};

export const fetchWidgetConfig = (overrideHeaders) => {
  const request = {
    method: 'get',
    url: BeEndpoints.WIDGET_CONFIG,
  };
  return requestService(
    null,
    request,
    (d) => d.data,
    null,
    null,
    overrideHeaders,
  );
};



// WEBPACK FOOTER //
// ./api/controllers/widgetControllers.js